/*
 * @Descripttion:
 * @version:
 * @Author: zhubaodong
 * @Date: 2021-09-10 17:19:03
 * @LastEditors: zhubaodong
 * @LastEditTime: 2023-02-28 16:28:33
 */
import Vue from "vue";
const view = Vue.extend({ render: h => h("router-view") });

// CPA线索数据
const cpa = () => import("@/views/boss/cpa/index.vue");
// CPS线索数据
const cps = () => import("@/views/boss/cps/index.vue");
//海外课表
const overseaCourse = () => import("@/views/boss/overseaCourse/index.vue");
// 智齿客服系统-入口页（区分销售/教务）
const customerSystem = () =>
  import(
    /* webpackChunkName: "customer-system" */ "@/views/boss/customer/entryPage.vue"
  );
// 智齿客服系统-教务首页
const eduHome = () =>
  import(
    /* webpackChunkName: "customer-eduHome" */ "@/views/boss/customer/eduIndex.vue"
  );
// 智齿客服-退费列表
const refundList = () =>
  import(
    /* webpackChunkName: "refund-list" */ "@/views/boss/customer/deepPages/refundList.vue"
  );
// 智齿客服-退费详情
const refundDetail = () =>
  import(
    /* webpackChunkName: "refund-detail" */ "@/views/boss/customer/deepPages/refundDetail.vue"
  );
// 智齿客服-邀约排课
const arrangementClass = () =>
  import(
    /* webpackChunkName: "arrangement-class" */ "@/views/boss/customer/deepPages/arrangementClass.vue"
  );

// 智齿客服-个人信息页-金币
const checkCoins = () =>
  import(
    /* webpackChunkName: "check-components" */ "@/views/boss/customer/components/basicInfo/checkCoins.vue"
  );

// 智齿客服-个人信息页-请假
const checkLeaves = () =>
  import(
    /* webpackChunkName: "checkleave-components" */ "@/views/boss/customer/components/basicInfo/checkLeave.vue"
  );

// 智齿客服-学生课表
const studentSchedules = () =>
  import(
    /* webpackChunkName: "student-schedules" */ "@/views/boss/customer/deepPages/teacherSchedules.vue"
  );
// 智齿客服-课时明细
const classHourDetail = () =>
  import(
    /* webpackChunkName: "classHour-Detail" */ "@/views/boss/customer/components/basicInfo/classHourDetail.vue"
  );
// 智齿客服-审批详情
const approveDetail = () =>
  import(
    /* webpackChunkName: "approve-detail" */ "@/views/boss/customer/components/basicInfo/approveDetail.vue"
  );
// 智齿客服-休学明细
const dropDetail = () =>
  import(
    /* webpackChunkName: "suspension-of-schoole" */ "@/views/boss/customer/components/basicInfo/dropDetail.vue"
  );
// 智齿客服-服务协议
const agreement = () =>
  import(
    /* webpackChunkName: "order-agreement" */ "@/views/boss/customer/deepPages/agreement.vue"
  );
// 智齿客服-商城订单详情
const mallOrderDetail = () =>
  import(
    /* webpackChunkName: "mall-order-detail" */ "@/views/boss/customer/deepPages/mallOrderDetail.vue"
  );
// 智齿客服-课消规则
const classRulesElimination = () =>
  import(
    /* webpackChunkName: "class-rules-elimination" */ "@/views/boss/customer/deepPages/classRulesElimination.vue"
  );
// 智齿客服-商城物品详情
const mallGoodsDetail = () =>
  import(
    /* webpackChunkName: "mall-goods-detail" */ "@/views/boss/customer/deepPages/mallGoodsDetail.vue"
  );
// 智齿客服-书画院体验课参课权操作记录
const experienceRecord = () =>
  import(
    /* webpackChunkName: "experience-record" */ "@/views/boss/customer/deepPages/experienceRecord.vue"
  );
// 智齿客服-书画院作品详情
const shyWorkDetail = () =>
  import(
    /* webpackChunkName: "shy-work-detail" */ "@/views/boss/customer/deepPages/shyWorkDetail.vue"
  );
// 智齿客服-班级记录-学生列表
const studentListsForClassRecord = () =>
  import(
    /* webpackChunkName: "student-lists-for-class-record" */ "@/views/boss/customer/deepPages/studentListsForClassRecord.vue"
  );
// 智齿客服-班级记录-班级课表
const scheduleForClassRecord = () =>
  import(
    /* webpackChunkName: "schedule-for-class-record" */ "@/views/boss/customer/deepPages/scheduleForClassRecord.vue"
  );
// 智齿客服-班级记录-班级操作日志
const operationLogForClassRecord = () =>
  import(
    /* webpackChunkName: "operation-log-for-class-record" */ "@/views/boss/customer/deepPages/operationLogForClassRecord.vue"
  );
// 智齿客服-物流信息-问题反馈
const feedBack = () =>
  import(
    /* webpackChunkName: "feedBack" */ "@/views/boss/customer/deepPages/feedBack.vue"
  );

// 企业微信-转介绍海报
const referralPoster = () =>
  import(
    /* webpackChunkName: "referral-poster" */ "@/views/boss/customer/components/referralPoster/index.vue"
  );

// 企业微信-转介绍截图
const referralScreenshot = () =>
  import(
    /* webpackChunkName: "referral-screenshot" */ "@/views/boss/customer/components/referralScreenshot/index.vue"
  );
// 智齿客服系统-销售首页
const saleHome = () =>
  import(
    /* webpackChunkName: "customer-saleHome" */ "@/views/boss/customer/saleIndex.vue"
  );

export default {
  path: "/boss",
  component: view,
  children: [
    {
      path: "cpa",
      component: cpa
    },
    {
      path: "cps",
      component: cps
    },
    {
      path: "overseaCourse",
      component: overseaCourse
    },
    {
      name: "customerSystem",
      path: "customerSystem",
      component: customerSystem,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      name: "eduHome",
      path: "eduHome",
      component: eduHome
    },
    {
      name: "saleHome",
      path: "saleHome",
      component: saleHome
    },
    {
      name: "refundList",
      path: "refundList",
      component: refundList
    },
    {
      name: "refundDetail",
      path: "refundDetail",
      component: refundDetail
    },
    {
      //查看金币
      name: "checkCoin",
      path: "checkCoin",
      component: checkCoins
    },
    {
      //请假列表
      name: "checkLeave",
      path: "checkLeave",
      component: checkLeaves
    },
    {
      name: "arrangementClass",
      path: "arrangementClass",
      component: arrangementClass
    },
    {
      name: "studentSchedules",
      path: "studentSchedules",
      component: studentSchedules
    },
    {
      //课时明细
      name: "classHourDetail",
      path: "classHourDetail",
      component: classHourDetail
    },
    {
      //审批详情
      name: "approveDetail",
      path: "approveDetail",
      component: approveDetail
    },
    {
      //休学明细
      name: "dropDetail",
      path: "dropDetail",
      component: dropDetail
    },
    {
      // 订单服务协议
      name: "agreement",
      path: "agreement",
      component: agreement
    },
    {
      // 商城订单详情
      name: "mallOrderDetail",
      path: "mallOrderDetail",
      component: mallOrderDetail
    },
    {
      // 课消规则
      name: "classRulesElimination",
      path: "classRulesElimination",
      component: classRulesElimination
    },
    {
      // 商城物品详情
      name: "mallGoodsDetail",
      path: "mallGoodsDetail",
      component: mallGoodsDetail
    },
    {
      // 书画院体验课参课权操作记录
      name: "experienceRecord",
      path: "experienceRecord",
      component: experienceRecord
    },
    {
      // 书画院 作品详情
      name: "shyWorkDetail",
      path: "shyWorkDetail",
      component: shyWorkDetail
    },
    {
      // 班级记录 学生列表
      name: "studentListsForClassRecord",
      path: "studentListsForClassRecord",
      component: studentListsForClassRecord
    },
    {
      // 班级记录 班级课表
      name: "scheduleForClassRecord",
      path: "scheduleForClassRecord",
      component: scheduleForClassRecord
    },
    {
      // 班级记录 班级操作记录
      name: "operationLogForClassRecord",
      path: "operationLogForClassRecord",
      component: operationLogForClassRecord
    },
    {
      // 物流信息 问题反馈
      name: "feedBack",
      path: "feedBack",
      component: feedBack
    },
    {
      // 企业微信-转介绍海报
      name: "ReferralPoster",
      path: "referralPoster",
      component: referralPoster
    },
    {
      // 企业微信-转介绍截图
      name: "ReferralScreenshot",
      path: "referralScreenshot",
      component: referralScreenshot
    }
  ]
};
